var render = function render(){var _vm=this,_c=_vm._self._c;return _c('power-mode',{ref:"pm",staticClass:"effect-preview",attrs:{"preset":_vm.preset,"show-combo":false,"shake":false,"particle-count":8}})
}
var staticRenderFns = []

export { render, staticRenderFns }